export default __webpack_public_path__ + "static/media/Tools.87db3be0.svg";